<template>
  <IQOS required>
    <template #title>
      <div
        :class="{
          'green-5-color': stage == 2,
        }"
      >
        {{ $t('quickstart_survey.title') }}
      </div>
    </template>

    <template #actions>
      <div class="v1-grey-6-color" v-if="stage < 2">
        <span class="bold" v-if="stage == 0"> {{ $t('quickstart_survey.steps') }} • </span>  {{ $t('quickstart_survey.eta') }}
      </div>

      <div class="qrw-heading-xs green-5-color bold" v-if="stage == 2">
        {{ $t('quickstart_survey.done') }}
      </div>
    </template>

    <div class="mt-16 gap-row-xs" v-if="stage == 0">
      <div class="qrw-heading-xs v1-grey-10-color">
         {{ $t('quickstart_survey.motd') }}
      </div>
      <BaseDivider color="v1-grey-4" />
      <div class="gap-column-1xs">
        <BaseButton variant="primary" size="md" bold @click="stage = 1">
          {{ $t('quickstart_survey.start_btn') }}
        </BaseButton>
        <BaseButton variant="secondary" size="md" color="v1-grey-6">
          {{ $t('quickstart_survey.skip_btn') }}
        </BaseButton>
      </div>
    </div>

    <div class="mt-16 gap-row-xs" v-else-if="stage == 1">
      <div class="qrw-label-sm bold v1-grey-10-color">
        {{ $t('quickstart_survey.select') }}
      </div>
      <BaseCheckbox
        :value="selected_survey.includes(k)"
        @input="onSurveyOptionSelected(k)"
        v-for="(v, k) in survey_options"
        :key="k"
      >
        {{  $t('quickstart_options.'+k) }}
      </BaseCheckbox>
      <BaseDivider color="v1-grey-4" />
      <div class="gap-column-1xs">
        <BaseButton
          variant="primary"
          size="md"
          color="green-5"
          bold
          @click="finishSurvey"
        >
          {{ $t('quickstart_survey.confirm_btn') }}
        </BaseButton>
        <BaseButton variant="secondary" size="md" color="v1-grey-6" @click="finishSurvey">
          {{ $t('quickstart_survey.skip_btn') }}
        </BaseButton>
      </div>
    </div>

    <div class="mt-16 gap-row-xs" v-else-if="stage == 2">
      <div class="qrw-label-sm bold v1-grey-10-color">
        {{  $t('quickstart_survey.select') }}
      </div>
      <div class="system-row w-100" v-for="(v, k) in survey_options" :key="k">
        <BaseCheckbox
          :value="selected_survey.includes(k)"
          @input="onSurveyOptionSelected(k)"
        >
          {{ $t('quickstart_options.'+k) }}
        </BaseCheckbox>
        <div class="qrw-heading-xs bold v1-grey-10-color" v-if="selected_survey.includes(k)">
          {{ formatSystemName(v) }}
        </div>
      </div>
      <BaseDivider color="v1-grey-4" />
      <div class="gap-column-xs w-100 finish-actions">
        <div class="w-100 v1-grey-7-color qrw-paragraph-md">
          {{ $t('quickstart_survey.last_comment') }}
        </div>
        <BaseButton
          class="connect-button"
          variant="primary"
          bold
          size="md"
          color="green-5"
          @click="connectRelatedSystems"
          v-if="canConnectRelatedSystems"
        >
          {{ $t('quickstart_survey.connect_btn') }}
        </BaseButton>
      </div>
    </div>
  </IQOS>
</template>

<script>
export default {
  data() {
    return {
      stage: 0,
      
      survey_options: {
        digital_menu: "inside",
        online_pay_inside: "inside",
        waiter_call: "inside",
        takeaway: "preorder",
        pager_alt: "preorder",
        custom_delivery: 'delivery',
        phone_alt: 'delivery',
        reservations: 'reserve',
        kiosk: 'preview'
      },

      selected_survey: [],
    };
  },
  methods: {
    formatSystemName(mode) {
      return {
        inside: "INSIDE",
        delivery: "DELIVERY",
        preorder: "TAKEAWAY",
        reserve: "RESERVE",
        preview: "PREVIEW",
      }[mode];
    },
    onSurveyOptionSelected(k) {
      const idx = this.selected_survey.findIndex((it) => it == k);

      if (idx !== -1) {
        this.selected_survey.splice(idx, 1);
      } else {
        this.selected_survey.push(k);
      }
    },
    finishSurvey() {
      this.stage = 2;
      this.$store.commit('patchCafeGeneralData', {
        quickstart_survey: this.selected_survey
      });
      this.$store.dispatch('saveCafe');
    },
    connectRelatedSystems() {
      const modes = Object.assign({}, this.cafe.modes);

      for (const system of this.selectedSurveySystems) {
        modes[system] = true;
      }

      this.$store.commit('patchCafeGeneralData', {
        modes
      });
      this.$store.dispatch('saveCafe');
    }
  },
  mounted() {
    if (this.cafe.quickstart_survey && this.cafe.quickstart_survey.length) {
      this.selected_survey = this.cafe.quickstart_survey;
      this.stage = 2;
    }
  },
  computed: {
    selectedSurveySystems() {
      return this.selected_survey.map(k => this.survey_options[k]);
    },
    canConnectRelatedSystems() {
      return !this.selectedSurveySystems.every(k => this.cafe.modes[k])
    },
    cafe() {
      return this.$store.state.cafe;
    }
  }
};
</script>

<style scoped>
.system-row {
  display: flex;
  justify-content: space-between;
}

.connect-button {
  min-width: fit-content;
}

.finish-actions,
.system-row {
  align-items: center;
  align-content: center;
}
</style>